export const SET_DATE_RANGE = "SET_DATE_RANGE";
export const SET_DATE_PICKER_VISIBILITY = "SET_DATE_PICKER_VISIBILITY";
export const OPEN_DATE_PICKER = "OPEN_DATE_PICKER";

export const setDateRange = range => ({
  type: SET_DATE_RANGE,
  range
});

export const closeDatePicker = () => ({
  type: SET_DATE_PICKER_VISIBILITY,
  visible: false
});

export const openDatePicker = range => ({
  type: OPEN_DATE_PICKER,
  range
});



// WEBPACK FOOTER //
// ./src/actions/datepicker.js